import { createAction, props } from "@ngrx/store";

export const getProfessionalFuelData = createAction(
  "[Professional Fuel] Get All Professional Fuel Data Action",
  props<{ dates: any; options: any }>()
);
export const loadProfessionalFuelData = createAction(
  "[Professional Fuel] Load All Professional Fuel Data Action",
  props<{ response: any[] }>()
);
export const getGenerateProfessionalFuelData = createAction(
  "[Professional Fuel] Get Professional Fuel Generate Action"
);
export const loadGenerateProfessionalFuelData = createAction(
  "[Professional Fuel] Load All Professional Fuel Generate Action",
  props<{ response: any[] }>()
);
export const setLoadingProfessionalStart = createAction(
  "[Professional Fuel] Load Professional Fuel Start Action"
);
export const setLoadingProfessionalEnd = createAction(
  "[Professional Fuel] Load Professional Fuel End Action"
);
export const resetProfessionalFuel = createAction(
  "[Professional Fuel] Reset Professional Fuel Action"
);
export const resetProfessionalFuelTotalizer = createAction(
  "[Professional Fuel] Reset Professional Fuel Totalizer Action"
);

// Bottom actions are for Professional Fuel ES
export const getProfessionalFuelEsData = createAction(
  "[Professional Fuel Es] Get All Professional Fuel ES Data Action",
  props<{ dates: any; partyCode: string; options: any }>()
);
export const getGenerateProfessionalFuelEsData = createAction(
  "[Professional Fuel ES] Get Professional Fuel ES Generate Action"
);
